<template>
  <div class="messenger-send">
    <div class="messenger-send__input">
      <div class="messenger-send-input">
        <textarea
          ref="send"
          v-model="data.text"
          class="messenger-send-input__text"
          :class="{'is-focused': data.text !== ''}"
          @keydown="handleKeyDown"
        >
        </textarea>
        <div class="attach-button">
          <vs-dropdown
            vs-trigger-click
          >
            <button
              class="attach-icon"
              type="button"
              aria-label="attach file"
            >
              <feather-icon
                icon="PaperclipIcon"
              />
            </button>
            <vs-dropdown-menu>
              <vs-dropdown-item @click.prevent="showPopupAddImage = true">Фото</vs-dropdown-item>
              <vs-dropdown-item @click.prevent="showPopupAddFile = true">Файл</vs-dropdown-item>
              <vs-dropdown-item @click.prevent="showPopupAddLocation = true">Локация</vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
        </div>
      </div>
    </div>
    <div class="messenger-send__button">
      <button
        class="messenger-send-button"
        type="submit"
        aria-label="send message"
        @click.prevent="prepareMessage('text')"
      >
        Отправить
      </button>
    </div>

    <vs-popup
      v-if="showPopupAddImage"
      :active.sync="showPopupAddImage"
      title="Прикрепить изображение"
    >
      <attach-image
        v-model="data.imageKey"
        @send="prepareMessage('image')"
      />
    </vs-popup>

    <vs-popup
      v-if="showPopupAddFile"
      :active.sync="showPopupAddFile"
      title="Прикрепить файл"
    >
      <attach-file
        v-model="data.fileKey"
        @send="prepareMessage('file')"
      />
    </vs-popup>

    <vs-popup
      v-if="showPopupAddLocation"
      :active.sync="showPopupAddLocation"
      title="Прикрепите локацию"
    >
      <attach-location
        v-model="data.location"
        @send="prepareMessage('location')"
      />
    </vs-popup>
  </div>
</template>

<script>
import autosize from 'autosize'

import { mapGetters } from 'vuex'
import { copyObject } from '@/helpers/helpers'

import Message from '@/api/http/models/Message'

import AttachImage from './AttachImage.vue'
import AttachFile from './AttachFile.vue'
import AttachLocation from './AttachLocation.vue'

export default {
  components: {
    AttachImage,
    AttachFile,
    AttachLocation
  },

  data () {
    return {
      data: {
        text: '',
        fileKey: '',
        imageKey: '',
        location: {
          address: '',
          latitude: '',
          longitude: ''
        }
      },
      showPopupAddImage: false,
      showPopupAddFile: false,
      showPopupAddLocation: false
    }
  },

  computed: mapGetters(['authUserCompany', 'currentClient']),

  mounted () {
    autosize(this.$refs.send)
    this.$refs.send.focus()
  },

  methods: {
    async handleKeyDown (event) {
      // Нажатие на enter
      if (event.keyCode === 13) {
        // Перенос строки на ctrl (cmd) || shift + enter
        if (event.metaKey || event.ctrlKey || event.shiftKey) {
          this.data.text = `${ this.data.text }\n`
          this.$nextTick(() => {
            autosize.update(this.$refs.send)
          })

          // Отправка на enter
        } else {
          event.preventDefault()
          await this.prepareMessage('text')
          this.$nextTick(() => {
            autosize.update(this.$refs.send)
          })
        }
      }
    },

    async prepareMessage (type) {
      const data = copyObject(this.data)
      this.resetData()

      const payload = {
        message_type: type,
        body: data.text,
        additional_data: {
          'location.latitude': data.location.latitude,
          'location.longitude': data.location.longitude,
          'location.address': data.location.address,
          'image.key': data.imageKey,
          'file.key': data.fileKey
        }
      }

      if (
        payload.message_type === 'text'
        && payload.body
      ) {
        this.sendMessage(payload)
      }

      if (
        payload.message_type === 'image'
        && payload.additional_data['image.key']
      ) {
        this.sendMessage(payload)
      }

      if (
        payload.message_type === 'file'
        && payload.additional_data['file.key']
      ) {
        this.sendMessage(payload)
      }

      if (
        payload.message_type === 'location'
        && payload.additional_data['location.latitude']
        && payload.additional_data['location.longitude']
        && payload.additional_data['location.address']
      ) {
        this.sendMessage(payload)
      }
    },

    async sendMessage (payload) {
      const response = await Message.send(this.authUserCompany.slug, this.currentClient.client_id, payload)
      if (response.status === 'not_permitted') {
        const message = response.message || 'В данный момент вы не можете написать в этот чат.'
        this.$vs.notify({
          time: '5000',
          color: 'danger',
          title: 'Ошибка при отправке',
          text: message
        })
      }
    },

    resetData () {
      this.data.text = ''
      this.data.fileKey = ''
      this.data.imageKey = ''

      this.data.location.longitude = ''
      this.data.location.latitude = ''
      this.data.location.address = ''

      this.showPopupAddImage = false
      this.showPopupAddFile = false
      this.showPopupAddLocation = false

      this.$nextTick(() => {
        autosize.update(this.$refs.send)
      })
    }
  }
}
</script>
